import { PATIENT_CALLS } from 'utils/reducers';

const initialState = {
    show: false,
};

const showPatientCallsReducer = (state = initialState, action) => {
    switch (action.type) {
        case PATIENT_CALLS.display:
            return { ...state, show: true };
        case PATIENT_CALLS.hide:
            return { ...state, show: false };
        default:
            return state;
    }
};

export default showPatientCallsReducer;
